/* Vazzari — inject the sticky film-reel strip into the header (visibility handled in CSS via data-sticky-state) */
(function(){
  var TXT='JOIN THE SOCIETY // ASTUTE SOCIETY // MADE FRESH. NOT STOCKED IN BAGS. // THINK \u00b7 ACT \u00b7 DISRUPT // ';
  function build(){
    var h=document.getElementById('header-component');
    if(!h||h.querySelector(':scope > .vz-reel'))return;
    var a=document.createElement('a');
    a.className='vz-reel';a.href='/pages/fashion-society-loyalty';
    a.setAttribute('aria-label','Join the Astute Society');
    var t=document.createElement('span');t.className='vz-reel__track';t.setAttribute('aria-hidden','true');
    for(var i=0;i<8;i++){var s=document.createElement('span');s.className='vz-reel__txt';s.textContent=TXT;t.appendChild(s);}
    a.appendChild(t);h.appendChild(a);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',build);else build();
  document.addEventListener('shopify:section:load',build);
})();
